import { Role } from "access/definitions";

export function getDomainRole(_role: Role) {
    const host = window.location.hostname
    // logger.debug('host', host)

    const mapping: { [k: string]: Role } = {
        'localhost': _role,
        'pro.hachimind.com': 'pro_band0',
        'users.hachimind.com': 'user_band0',
        'app.hachimind.com': 'user_band0',
    }
    const role: Role = mapping[host] ?? _role;

    return { role, host }
}
